<template>
  <h2 :class="cn('text-sm uppercase font-medium', $attrs.class)">
    <slot />
  </h2>
</template>

<script lang="ts" setup></script>

<style></style>
